import { api } from "./api";

export const feedbackAllList = async (addUrl) => {
  let url = `feedback/all/list?${addUrl}`;
  return await api.get(url);
};
export const feedbackDelete = async (data) => {
  return await api.post("feedback/delete", data);
};

export const addFeedback = async (data) => {
  return await api.post("/feedback/add", data);
};
